/**
 * CAVALCARE - Premium Blog Article Enhancements
 * Table of Contents, Reading Progress, Reading Time, Smooth Scroll
 */

(function () {
  'use strict';

  const SELECTORS = {
    content: '.article-template__content',
    readingTime: '.cavalcare-blog-meta__reading-time',
    progressBar: '.cavalcare-reading-progress__bar',
    tocNav: '#cavalcare-toc-nav',
    tocContainer: '.cavalcare-blog-toc',
    tocToggle: '.cavalcare-blog-toc__toggle',
  };

  const WORDS_PER_MINUTE = 200;

  /* --- Reading Time --- */
  function initReadingTime() {
    var content = document.querySelector(SELECTORS.content);
    var readingTimeEls = document.querySelectorAll(SELECTORS.readingTime);
    if (!content || readingTimeEls.length === 0) return;

    var text = content.textContent || content.innerText || '';
    var wordCount = text.trim().split(/\s+/).length;
    var minutes = Math.max(1, Math.round(wordCount / WORDS_PER_MINUTE));

    readingTimeEls.forEach(function (el) {
      el.textContent = minutes + ' min de lecture';
    });
  }

  /* --- Table of Contents --- */
  function initTableOfContents() {
    var content = document.querySelector(SELECTORS.content);
    var tocNav = document.querySelector(SELECTORS.tocNav);
    var tocContainer = document.querySelector(SELECTORS.tocContainer);
    if (!content || !tocNav || !tocContainer) return;

    var headings = content.querySelectorAll('h2, h3');
    if (headings.length < 2) {
      tocContainer.classList.add('cavalcare-blog-toc--empty');
      return;
    }

    var ul = document.createElement('ul');
    var usedIds = {};

    headings.forEach(function (heading) {
      // Generate a unique ID
      var baseId = slugify(heading.textContent);
      var id = baseId;
      var counter = 1;
      while (usedIds[id]) {
        id = baseId + '-' + counter;
        counter++;
      }
      usedIds[id] = true;
      heading.id = id;

      // Create TOC item
      var li = document.createElement('li');
      li.className = heading.tagName === 'H3' ? 'toc-h3' : 'toc-h2';

      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = heading.textContent.trim();
      li.appendChild(a);
      ul.appendChild(li);
    });

    tocNav.appendChild(ul);
    initTOCHighlight(headings);
    initSmoothScroll(tocNav);
  }

  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/[^a-z0-9\s-]/g, '') // Remove special chars
      .replace(/\s+/g, '-') // Spaces to dashes
      .replace(/-+/g, '-') // Collapse dashes
      .substring(0, 60);
  }

  /* --- TOC Active Highlight (IntersectionObserver) --- */
  function initTOCHighlight(headings) {
    var tocNav = document.querySelector(SELECTORS.tocNav);
    if (!tocNav || !('IntersectionObserver' in window)) return;

    var tocLinks = tocNav.querySelectorAll('a');
    var linkMap = {};
    tocLinks.forEach(function (link) {
      linkMap[link.getAttribute('href').substring(1)] = link;
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // Remove active from all
            tocNav.querySelectorAll('li.active').forEach(function (li) {
              li.classList.remove('active');
            });
            // Add active to current
            var link = linkMap[entry.target.id];
            if (link) {
              link.parentElement.classList.add('active');
            }
          }
        });
      },
      {
        rootMargin: '-10% 0px -80% 0px',
        threshold: 0,
      }
    );

    headings.forEach(function (heading) {
      observer.observe(heading);
    });
  }

  /* --- Smooth Scroll --- */
  function initSmoothScroll(tocNav) {
    if (!tocNav) return;

    tocNav.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link) return;

      var targetId = link.getAttribute('href');
      if (!targetId || targetId.charAt(0) !== '#') return;

      var target = document.getElementById(targetId.substring(1));
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // Update URL without scroll jump
      if (history.pushState) {
        history.pushState(null, null, targetId);
      }
    });
  }

  /* --- Reading Progress Bar --- */
  function initReadingProgress() {
    var bar = document.querySelector(SELECTORS.progressBar);
    var content = document.querySelector(SELECTORS.content);
    if (!bar || !content) return;

    var ticking = false;

    function updateProgress() {
      var rect = content.getBoundingClientRect();
      var contentTop = rect.top + window.scrollY;
      var contentHeight = content.offsetHeight;
      var viewportHeight = window.innerHeight;
      var scrollTop = window.scrollY;

      var progress = (scrollTop - contentTop + viewportHeight * 0.3) / (contentHeight - viewportHeight * 0.5);
      progress = Math.min(1, Math.max(0, progress));

      bar.style.width = (progress * 100).toFixed(1) + '%';
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(updateProgress);
          ticking = true;
        }
      },
      { passive: true }
    );

    // Initial call
    updateProgress();
  }

  /* --- Mobile TOC Toggle --- */
  function initMobileTOCToggle() {
    var toggle = document.querySelector(SELECTORS.tocToggle);
    var nav = document.querySelector(SELECTORS.tocNav);
    if (!toggle || !nav) return;

    // Start collapsed on mobile
    if (window.innerWidth < 990) {
      toggle.setAttribute('aria-expanded', 'false');
      nav.setAttribute('aria-hidden', 'true');
    }

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.setAttribute('aria-hidden', String(expanded));
    });
  }

  /* --- Init --- */
  document.addEventListener('DOMContentLoaded', function () {
    initReadingTime();
    initTableOfContents();
    initReadingProgress();
    initMobileTOCToggle();
  });
})();
